<template>
  <div class="margin-subpages">
    <el-collapse v-model="activeCollapse">
      <el-collapse-item title="Switch Language" name="Switch_Language">
        <div>
          <div>{{ $t("global.test") }}</div>
          <div>
            <el-button @click="setLanguage('EN')" type="primary">EN</el-button>
            <el-button @click="setLanguage('TH')" type="primary">TH</el-button>
            <el-button @click="setLanguage('FALSE')" type="danger">FALSE</el-button>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="Chat" name="chat">
        <div class="fs-18 fw-700">Feature (Demo)</div>
        <div class="fs-16 fw-500 opa-04 mt-12">Detect URLs : DONE</div>
        <div class="fs-14 opa-04">- Detect URLs form input</div>
        <div class="fs-14 opa-04">- Show a tag and can open link!</div>
        <div class="fs-16 fw-500 opa-09 mt-4">@mentions : DOING</div>
        <div class="fs-14 opa-04">- Search user fomr @..</div>
        <div class="fs-14 opa-08">
          - disable edit for @mentions when user selected form list
        </div>
        <div class="fs-14 opa-08">- show Highlight in chat</div>
        <div class="fs-14 opa-08">- show detail on hover @mentions</div>
        <div class="mt-32">
          <span class="fs-12 opa-04">
            [Ali Alies, Beatriz Beatroze, Beatriz Mit, Beatriz Hrolla, Charles
            Prello, Diya Mania, Eric Poomchai]
          </span>
          <div class="fs-20 fw-700">
            What can we do to create a happier workplace?
          </div>
          <div
            class="mt-10"
            v-for="(message, index) in conversation"
            :key="message.id + '_' + index"
          >
            <div class="flex-center">
              <div class="fs-24 fw-900 mx-10 opa-08">{{ message.name }}</div>
              <div>
                <div class="fs-16" v-html="message.text"></div>
                <div class="fs-14 opa-06">
                  {{ message.fullname }} - <span>{{ message.time }}</span>
                </div>
              </div>
            </div>
          </div>
          <form @submit.prevent="sendReply" ref="sendReplyText">
            <input
              class="input input-text mt-20"
              v-model="messageInput"
              type="text"
              @keyup="searchMember(messageInput)"
            />
            <input
              class="input ml-8"
              @click.prevent="sendReply"
              type="submit"
              value="Submit"
            />
            <div v-if="this.searchMemberArr.length > 0">
              <div
                class="my-10 fs-12"
                v-for="mem in this.searchMemberArr"
                :key="mem.id + '_searching'"
              >
                <div>{{ mem.fullname }}</div>
                <div class="opa-06 fs-10">{{ mem.email }}</div>
              </div>
            </div>
          </form>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: "logo",
  components: {
    Member: require("@/components/content/user-profile-details").default,
  },
  data() {
    return {
      messageInput: "",
      activeCollapse: ["Switch_Language"],
      searchMemberArr: [],
      conversation: [
        {
          text: `The work environment could use more color and decor. Also, my desk smells terrible. <a href="https://happily.ai/">https://happily.ai/</a>`,
          user: "beatriz@email.com",
          name: "BB",
          fullname: "Beatriz Beatroze",
          id: "beatriz",
          time: "Tue Dec 28 2021 13:48:40 GMT+0700 (Indochina Time)",
        },
        {
          text: `I think this is a great idea! I’ll plan to make this happen sometime next month.`,
          user: "jonathan_s@email.com",
          name: "JS",
          fullname: "Jonathan Smith",
          id: "jonathan_smithsaldfjsd5652",
          time: "Tue Dec 28 2021 14:02:40 GMT+0700 (Indochina Time)",
        },
        {
          text: `Thank you for helping me through it, Pls, Tell me if you need any help!`,
          user: "beatriz@email.com",
          name: "BB",
          fullname: "Beatriz Beatroze",
          id: "beatriz",
          time: "Tue Dec 28 2021 13:48:40 GMT+0700 (Indochina Time)",
        },
      ],
      member: [
        {
          name: "AA",
          fullname: "Ali Alies",
          email: "ali_a@email.com",
          id: "ali1B111",
        },
        {
          name: "BB",
          fullname: "Beatriz Beatroze",
          email: "beatriz_b@email.com",
          id: "beatriz1N111",
        },
        {
          name: "BB",
          fullname: "Beatriz Mit",
          email: "beatriz_m@email.com",
          id: "beatrizM1111",
        },
        {
          name: "BB",
          fullname: "Beatriz Hrolla",
          email: "beatriz_h@email.com",
          id: "beatriz1111",
        },
        {
          name: "CT",
          fullname: "Charles Prello",
          email: "charles_p@email.com",
          id: "charles1111",
        },
        {
          name: "DM",
          fullname: "Diya Mania",
          email: "diya_m@email.com",
          id: "diya1111",
        },
        {
          name: "EP",
          fullname: "Eric Poomchai",
          email: "eric_p@email.com",
          id: "aeric1111",
        },
      ],
    };
  },
  methods: {
    setLanguage(lang) {
      if (lang == "EN" || lang == "TH" || lang == "FALSE") {
        localStorage.setItem("lang", lang);
        setTimeout(() => {
          location.reload(true);
          this.goto();
        }, 200)
      } else {
        localStorage.setItem("lang", "EN");
      }
    },
    sendReply(value) {
      value.preventDefault();
      this.conversation.push({
        text: this.urlify(this.messageInput),
        user: "jonathan_s@email.com",
        name: "JS",
        fullname: "Jonathan Smith",
        id: "jonathan_smithsaldfjsd5652",
        time: new Date(),
      });
      this.messageInput = "";
    },
    searchMember(str) {
      let regex = /\B@[a-z0-9_-]+/gi;
      let members = str.match(regex);
      if (members && members.length > 0) {
        let searchName = members[members.length - 1];
        let filtered = _.filter(this.member, (item) => {
          return (
            item.fullname
              .toLowerCase()
              .indexOf(searchName.toLowerCase().slice(1, searchName.length)) >
            -1
          );
        });
        if (filtered.length < this.member.length) {
          this.searchMemberArr = filtered;
        } else {
          this.searchMemberArr = [];
        }
      } else {
        this.searchMemberArr = [];
      }
    },
    urlify(text) {
      let urlRegex =
        /(\b(https?|http?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      return text.replace(urlRegex, (url) => {
        return '<a href="' + url + '">' + url + "</a>";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  width: 80px;
  padding: 4px;
  font-size: 18px;
}
.input-text {
  height: 20px;
  width: 360px;
}
</style>